<mat-form-field
  appearance="outline"
  class="sg-textarea-field sg-ui-component"
  [subscriptSizing]="subscriptSizing"
  [style.width]="width"
  [ngClass]="{ 'sg-variant-primary': variant === 'primary', 'sg-variant-secondary': variant === 'secondary', 'has-value': internalFormControl.value?.length > 0, 'has-placeholder': !!placeholder, 'no-label': !label || hideLabel }">
  <!-- Label -->
  @if (!hideLabel) {
  <mat-label>{{label}}</mat-label>
  }
  <!-- Textarea Field -->
  <textarea
    matInput
    [formControl]="internalFormControl"
    [placeholder]="effectivePlaceholder"
    [required]="isRequired"
    [cdkTextareaAutosize]="autoResize"
    [cdkAutosizeMinRows]="effectiveMinRows"
    [cdkAutosizeMaxRows]="effectiveMaxRows"
    [rows]="autoResize ? null : effectiveMinRows"
    (blur)="onInputBlur()"
    (focus)="onInputFocus()"></textarea>
  <!-- Hint -->
  @if (hint) {
  <mat-hint align="start" class="sg-textarea-hint sg-ui-component">{{hint}}</mat-hint>
  }
  <!-- Character Counter -->
  @if (maxLimit) {
  <mat-hint align="end" class="sg-textarea-character-counter sg-ui-component">{{valueLength}} / {{maxLimit}}</mat-hint>
  }
  <!-- Error Messages -->
  @if (hasErrors) {
  <mat-error class="sg-textarea-error sg-ui-component">{{getErrorMessage()}}</mat-error>
  }
</mat-form-field>
